module.exports = __webpack_public_path__ + "static/media/img_female_annimation4.a75e87dd.gif";